import React, { useEffect } from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { LAMINATE_SERVICE_PATH } from 'pages/common/consts/urls';
import { Floor } from 'assets';
import { gaShowElement } from 'ga-events/ga-view-element';
import { gaClickCalculateLaminate } from 'ga-events/ga-click-calculate-laminate';
import { PriceCalculateContainer, Title } from './styles';

const title = 'Укладка ламината от ';

export const LaminateCalculateBanner = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { services } = dimensions;

  const isValidService = services.length && services[0]?.priceMin;

  const price = isValidService ? Math.round(services[0].priceMin) : 0;

  useEffect(() => {
    if (isValidService) {
      gaShowElement({ title: `${title}${price} ₽` });
    }
  }, [isValidService, price]);

  if (!isValidService) {
    return null;
  }

  const handleButtonCalculateClick = (cost: string) => {
    gaClickCalculateLaminate({ cost });
    window.open(LAMINATE_SERVICE_PATH);
  };

  return (
    <>
      <Typography variant="h3">Помощь мастера</Typography>
      <PriceCalculateContainer>
        <Title>
          <Floor />
          <Typography size="body_accent" variant="m">
            {title}
            {price} ₽
          </Typography>
        </Title>
        <RegularButton
          invert
          size="m"
          variant="primary"
          onClick={() => handleButtonCalculateClick(`${title}${price} ₽`)}>
          Рассчитать
        </RegularButton>
      </PriceCalculateContainer>
    </>
  );
};
